import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.authenticate:
            return {
                ...state
            };
        case ActionTypes.logOut:
            return {};
        default:
            return state;
    }
};
export { reducer, getInitialState };
